var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"pageContent"}},[_c('TopBanner',{attrs:{"bg-img":_vm.bgImg,"sub-title":_vm.mainTitle}}),_c('TabDepthMenu',{attrs:{"tab-list":_vm.tabList}}),_c('router-view',{staticClass:"contents"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }